import { DedicateFlashDto } from '../../../dto/flashmessage/get/flashmessagedto';
import { MiddlewareDtoImpl } from '../../../dto/middlewaredto';
import { MiddlewareAPIResponse } from '../../middlewareapiresponse';

export interface GetDedicateFlashMessageResponse extends MiddlewareAPIResponse
{
    getDedicateFlashDtoDtos(): DedicateFlashDto[];
}

export class GetDedicateFlashMessageResponseDtoImpl extends MiddlewareDtoImpl implements GetDedicateFlashMessageResponse
{
    private dedicateFlashDto : DedicateFlashDto[];

    getDedicateFlashDtoDtos(): DedicateFlashDto[]
    {
        return this.dedicateFlashDto;
    }

    setDedicateFlashDtoDtos(dedicateFlashDto: DedicateFlashDto[])
    {
        this.dedicateFlashDto = dedicateFlashDto;
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/flashmessage/getdedicateflashmessages/getdedicateflashmessagesresponse.tsx